<template>
    <v-card outlined>
        <v-card-title class="d-flex align-center justify-space-between">
            <div :class="colorClass">{{ title }}</div>
            <div>
                <v-icon :color="iconColor">
                    {{ icon }}
                </v-icon>
            </div>
        </v-card-title>
        <v-divider />
        <v-card-text class="display-1 d-flex justify-space-between align-center" :class="colorClass">
            <span v-if="formatter">{{ formatter(value) }}</span>
            <span v-else>{{ value | separator }}</span>
            <span v-if="subText" class="subtitle-1"> {{ subText }}</span>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: [ 'icon', 'title', 'value', 'subText', 'target', 'nextTarget', 'formatter'],
    computed: {
        colorClass () {
            if (typeof this.target === 'undefined') return ''
            if (this.value >= this.nextTarget) return 'green--text x'
            else if (!this.nextTarget && this.value >= this.target) return 'green--text'
            else if (this.value >= this.target) return 'yellow--text text--darken-2'
            else return 'red--text'
        },
        iconColor () {
            if (typeof this.target === 'undefined') return ''
            if (this.value >= this.nextTarget) return 'green'
            else if (!this.nextTarget && this.value >= this.target) return 'green'
            else if (this.value >= this.target) return 'yellow darken-2'
            else return 'red'
        }
    }
}
</script>